import React, { useState } from "react";
import { Form, Row, Col, Offcanvas } from "react-bootstrap";
import RespIm from "./RespIm";
import "../css/botones.css";
function RecoverPassword(props) {
  const [validated, setValidated] = useState(false);
  const [estado, setEstado] = useState({ n: 0 });
  const [show, setShow] = useState({ show: false, message: "" });
  const handleClose = () => setShow({ show: false, message: "" });
  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    }
  };

  return (
    <div
      style={{
        alignContent: "center",
        paddingLeft: "1%",
        paddingRight: "1%",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <RespIm
          x0={1003}
          y0={700}
          x={300}
          src={require("../images/Logo.png").default}
        />
      </div>
      <div>
        <Offcanvas show={show.show} onHide={handleClose}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Posturalmente</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>{show.message}</Offcanvas.Body>
        </Offcanvas>
      </div>
      {(function () {
        switch (estado.n) {
          default:
            //Ingresar;
            return (
              <div>
                <Row
                  fluid
                  className="justify-content-center"
                  style={{ margin: "auto" }}
                >
                  <Col Col xs={12} xl={8}>
                    <p> Por favor ingresá tu nueva contraseña:</p>
                  </Col>
                </Row>
                <Row
                  fluid
                  className="justify-content-center"
                  style={{ margin: "auto" }}
                >
                  <Col Col xs={12} xl={8}>
                    <Form
                      noValidate
                      validated={validated}
                      onSubmit={handleSubmit}
                      id="Forma"
                    >
                      <Form.Group className="mb-3" controlId="userPassWord">
                        <Form.Label>Clave</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Ingrese su clave"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Por favor ingrese su clave
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group className="mb-3" controlId="userPassWord2">
                        <Form.Label>Clave</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Reingrese su clave"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          Por favor reingrese su clave
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Form>
                  </Col>
                </Row>

                <Row
                  fluid
                  className="justify-content-center"
                  style={{ paddingTop: "20px", margin: "auto" }}
                >
                  <Col xs={6} xl={3} className="text-center">
                    <button
                      class="botones2"
                      onClick={() => recuperarClave(props, setEstado)}
                    >
                      Enviar
                    </button>
                  </Col>
                  <Col Col xs={6} xl={3} className="text-center">
                    {"   "}
                    <button
                      class="botones2"
                      onClick={() => props.setEstado({ n: 0 })}
                    >
                      Volver
                    </button>
                  </Col>
                </Row>
                <Row
                  fluid
                  className="justify-content-center"
                  style={{ paddingTop: "60px", margin: "auto" }}
                >
                  <Col xs={12} xl={12} className="text-center"></Col>
                </Row>
              </div>
            );
          case 1:
            return (
              <div style={{ textAlign: "center" }}>
                <h6>
                  La contraseña fue modificada. Por favor ingresá con tu nueva
                  contraseña para disfrutar de tu contenido.
                </h6>
                <Row
                  fluid
                  className="justify-content-center"
                  style={{ paddingTop: "30px", margin: "auto" }}
                >
                  <Col xs={6} xl={4} className="text-center">
                    <button
                      class="botones2"
                      onClick={() => props.setEstado({ n: 1, data: {} })}
                    >
                      Ingresar
                    </button>
                  </Col>
                  <Col Col xs={6} xl={4} className="text-center">
                    {"   "}
                    <button
                      class="botones2"
                      onClick={() => props.setEstado({ n: 0, data: {} })}
                    >
                      Volver
                    </button>
                  </Col>
                </Row>
              </div>
            );
        }
      })()}
    </div>
  );

  function recuperarClave(props, setEstado) {
    const form = document.getElementById("Forma");
    if (form.checkValidity() === true) {
      const clave = document.getElementById("userPassWord").value;
      const clave2 = document.getElementById("userPassWord2").value;

      ///HAy que definir recover_amil,recover_clave y email. Estado en props.estado.nombre
      if (clave === clave2) {
        recoverPass(
          props.estado.data.user_email,
          clave,
          props.estado.data.email,
          props.estado.data.clave
        )
          .then((json) => {
            if (json.status !== 200) {
              setShow({
                show: true,
                message: json.message,
              });
            } else {
              setEstado({ n: 1 });
            }
          })
          .catch((error) => alert(error));
      } else {
        setShow({
          show: true,
          message: "Las contraseñas ingresadas no coinciden",
        });
      }
    } else {
      setValidated(true);
    }
  }
  async function recoverPass(email, clave, recover_mail, recover_clave) {
    const res = await fetch(
      "https://entrenamientopostural.com/services/PHP/newPassword.php",
      {
        method: "POST",
        headers: {
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },

        body: JSON.stringify({
          email: email,
          clave: clave,
          recoverClave: recover_clave,
          recoverMail: recover_mail,
        }),
      }
    );
    if (res.status === 200) {
      const json = await res.json();
      return json;
    } else {
      return { status: res.status, message: "error" };
    }
  }
}
export default RecoverPassword;
